
<template>
  <div :class="['notifications', { 'hide': !show }]">
    <transition name="fade">
      <div class="notifications__entry success" v-if="booked && show">
        <h3>Congratulations! You've booked your consultation</h3>
        <h5>{{ apptDate }}</h5>
        <button class="notifications__entry__view" @click="viewBooking" target="_blank">View booking details</button>
        <button class="notifications__entry__close" @click="show=false" v-html="'x'"/>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'BookedNotification',
  mounted() {
    const urlParams = new URLSearchParams(window.location.search)
    this.booked = urlParams.get('booked')
    const start = urlParams.get('start')
    this.apptDate = start ? new Date(Date.parse(start)) : ''
    this.url = urlParams.get('edit')
    if (this.booked && start && this.url) {
      setTimeout(() => {
        this.setTimelineStep(1)
      }, 500)
    }
  },
  data() {
    return {
      booked: false,
      apptDate: '',
      url: '',
      show: true
    }
  },
  methods: {
    ...mapActions([
      'setTimelineStep'
    ]),
    viewBooking() {
      window.open(this.url, '_blank')
    }
  }
}
</script>

<style lang="scss" scoped>
.notifications {
  position: absolute;
  z-index: 100;
  width: 100%;

  &__entry {
    padding: 2rem;
    width: 100%;
    text-align: center;
    background-color: $success-light;
    border-bottom: solid 1px $success;
    &__view {
      display: block;
      @include btn;
      margin: 1rem auto 0;
    }
    &__close {
      position: absolute;
      top: 1rem;
      right: 1rem;
    }
  }
  &.hide {
    .notifications__entry {
      height: 0;
      padding: 0;
      overflow: hidden;
    }
    .notifications__close {
      opacity: 0;
    }
  }
}
</style>